// disable eslint react/no-unescaped-entities
import * as React from 'react';

import { Breadcrumb, StyleSheet, breakPoint, css, font, fontWeight, spacing } from '@coursera/coursera-ui';

import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';
import type { BreadcrumbLink } from 'bundles/premium-certificate/constants/propTypes';

const styles = StyleSheet.create({
  DdpBreadcrumbsContainer: {
    marginBottom: spacing.lg,
  },
  breadcrumb: {
    color: 'inherit',
    textDecoration: 'none',
    lineHeight: spacing.md,
    fontWeight: fontWeight.bold,
    fontSize: '0.8rem',
    [`@media (max-width: ${breakPoint.sm}px)`]: {
      fontSize: font.sm,
      separator: {
        fontSize: font.sm,
      },
    },
    ':hover': {
      textDecoration: 'none',
      color: 'inherit',
    },
  },
  breadcrumbSeparator: {
    fontSize: '0.8rem',
    color: 'inherit',
    display: 'flex',
    marginLeft: '0.5rem',
    marginRight: '0.5rem',
  },
});

type Props = {
  links?: Array<BreadcrumbLink>;
  linkStyle?: any;
  separatorStyle?: any;
  rootClassName?: string;
};

function DdpBreadcrumbsContainer({ links, rootClassName, separatorStyle, linkStyle }: Props) {
  const linkStyles = css(styles.breadcrumb, linkStyle);
  const separatorClassName = css(styles.breadcrumbSeparator, separatorStyle).className;

  if (!links) return null;

  return (
    <div
      {...css('bt3-container m-l-0 p-a-0', styles.DdpBreadcrumbsContainer, rootClassName)}
      data-testid="ddp-breadcrumbs-container"
    >
      <div {...css('bt3-col-xs-12 p-a-0')}>
        <Breadcrumb separatorClassName={separatorClassName} separator=">">
          {links.map(({ href, label, type }) => (
            <Breadcrumb.Item key={`breadcrumb-${label}`}>
              {href ? (
                <TrackedLink2 {...linkStyles} href={href} trackingName="breadcrumb_link" data-e2e={type}>
                  {label}
                </TrackedLink2>
              ) : (
                <span {...linkStyles}>{label}</span>
              )}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </div>
    </div>
  );
}

export default DdpBreadcrumbsContainer;
